import { render, staticRenderFns } from "./tagEditing.vue?vue&type=template&id=4433def3&scoped=true&"
import script from "./tagEditing.vue?vue&type=script&lang=js&"
export * from "./tagEditing.vue?vue&type=script&lang=js&"
import style0 from "./tagEditing.vue?vue&type=style&index=0&id=4433def3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4433def3",
  null
  
)

export default component.exports